"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addFormErrors = addFormErrors;
var _react = _interopRequireDefault(require("react"));
function flatten_errors(errors) {
  var all_errors = {};
  for (var key in errors) {
    if (_.isArray(errors[key])) {
      if (_.isString(errors[key][0])) {
        all_errors[key] = errors[key];
      } else {
        for (var index in errors[key]) {
          if (_.isArray(errors[key][index])) {
            all_errors[key + "[".concat(index, "]")] = errors[key][index];
          } else {
            var sub_errors = flatten_errors(errors[key][index]);
            for (var key2 in sub_errors) {
              all_errors[key + "[".concat(index, "].") + key2] = sub_errors[key2];
            }
          }
        }
      }
    } else {
      var _sub_errors = flatten_errors(errors[key]);
      for (var _key in _sub_errors) {
        all_errors[key + '.' + _key] = _sub_errors[_key];
      }
    }
  }
  return all_errors;
}
function addFormErrors(errors, formApi) {
  var nonFieldErrorsField = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var all_errors = flatten_errors(errors);
  for (var key in all_errors) {
    var fieldKey = key;
    if (fieldKey === 'non_field_errors' && nonFieldErrorsField !== null) {
      fieldKey = nonFieldErrorsField;
    }
    if (formApi.fieldExists(fieldKey)) {
      formApi.setError(fieldKey, /*#__PURE__*/_react["default"].createElement("div", {
        dangerouslySetInnerHTML: {
          __html: all_errors[key]
        }
      }));
    }
  }
}